export type SelectionOption = "override" | "append";

export const SelectionValueMap: Record<SelectionOption, string> = {
  override: "1",
  append: "2",
};